module.exports = __webpack_public_path__ + "images/pages/fifth_anniversary_lp/campaign-mvBgImg_81dce2810bcc8dd17081f83858bbcc77.png";